<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      unit="打印筛选"
      id-key="UserId"
      in-dialog
      @close-saved="$emit('close-saved')"
    >
      <el-checkbox v-model="isSelfProduced" v-show="isSelfProducedShow"
        >自产</el-checkbox
      >
      <el-checkbox v-model="isOutsourcing" v-show="isOutsourcingShow"
        >委外</el-checkbox
      >

      <div
        style="font-size: 16px; margin-bottom: 18px; margin-top: 18px"
        v-show="outsourcingList.length !== 0 && isOutsourcing"
      >
        委外供应商
      </div>

      <el-checkbox-group
        v-model="checkList"
        v-show="outsourcingList.length !== 0 && isOutsourcing"
      >
        <el-checkbox
          v-for="item in outsourcingList"
          :label="item.name"
          :key="item.key"
        ></el-checkbox>
      </el-checkbox-group>

      <template slot="footer">
        <el-button type="primary" @click="toPrint">打印</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import { v } from "vxe-table";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      isSelfProduced: false,
      isOutsourcing: false,
      isSelfProducedShow: false,
      isOutsourcingShow: false,

      checkList: [],
      outsourcingList: [],
    };
  },
  methods: {
    setData(data) {
      this.isOutsourcingShow = data.isOutsourcingShow;
      this.isSelfProducedShow = data.isSelfProducedShow;
      this.outsourcingList = data.outsourcingList;
      this.checkList = [];
      this.isSelfProduced = false;
      this.isOutsourcing = false;
    },
    toPrint() {
      // 获取本地缓存的胶件，模具，材料信息
      let DetailModels = JSON.parse(localStorage.getItem("DetailModels"));
      let mouldBoms = JSON.parse(localStorage.getItem("mouldBoms"));
      let rubbers = JSON.parse(localStorage.getItem("rubbers"));

      let ClothRemark = localStorage.getItem("printClothRemark");
      let OrderDate = localStorage.getItem("printOrderDate");
      let OrderProductNo = localStorage.getItem("printOrderProductNo");
      let DpName = localStorage.getItem("printDpName");
      let FinishDate = localStorage.getItem("printFinishDate");
      let ProductName = localStorage.getItem("printProductName");

      // 构造要打印的数据

      // 只打印自产的
      if (this.isSelfProduced && !this.isOutsourcing) {
        // 获取自产的模具信息
        let selfMouldBoms = mouldBoms.filter((item) => {
          return item.ProductionType === 0;
        });

        // 获取对应模具的胶件和材料
        let selfMouldBomsIds = selfMouldBoms.map((item) => item.MouldBomNo);

        let selfRubbers = [];
        let selfDetailModels = [];

        rubbers.forEach((item) => {
          if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
            selfRubbers.push(item);
          }
        });

        DetailModels.forEach((item) => {
          if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
            selfDetailModels.push(...item.DetailModels);
          }
        });

        // 给胶件赋值上对应的工单号
        selfRubbers.forEach((item) => {
          for (let i = 0; i < selfMouldBoms.length; ++i) {
            if (item.MouldBomNo === selfMouldBoms[i].MouldBomNo) {
              item.WorkDocNo = selfMouldBoms[i].WorkDocNo;
              break;
            }
          }
        });

        //  合并材料
        let sumMaterialModels = [];

        let copyMaterialModels = JSON.parse(JSON.stringify(selfDetailModels));

        copyMaterialModels.forEach((item) => {
          let pds = sumMaterialModels.map((item) => item.ProductId);
          if (pds.indexOf(item.ProductId) === -1) {
            sumMaterialModels.push(item);
          } else {
            let length = sumMaterialModels.length;
            for (let i = 0; i < length; ++i) {
              if (item.ProductId === sumMaterialModels[i].ProductId) {
                sumMaterialModels[i].Quantity =
                  sumMaterialModels[i].Quantity + item.Quantity;
                break;
              }
            }
          }
        });

        let printData = {
          ClothRemark,
          OrderDate,
          OrderProductNo,
          DpName,
          FinishDate,
          ProductName,
          ProductModels: selfMouldBoms,
          RubberModels: selfRubbers,
          MaterialModels: selfDetailModels,
          sumMaterialModels: sumMaterialModels,
        };

        let printList = [];
        printList.push(printData);

        console.log("printList====", printList);

        // 缓存
        localStorage.setItem("printList", JSON.stringify(printList));

        this.$emit("printed");
        this.close();

        // 只打印委外的
      } else if (this.isOutsourcing && !this.isSelfProduced) {
        // 获取委外的模具信息
        let outMouldBoms = mouldBoms.filter((item) => {
          return item.ProductionType === 1;
        });

        // 没有勾选，默认全部加工商都要
        let outDpNames = [];
        if (this.checkList.length === 0) {
          outDpNames = outMouldBoms.map((item) => {
            return item.ProductionDpName;
          });
          outDpNames = Array.from(new Set(outDpNames));
        } else {
          outDpNames = this.checkList;
        }

        let printList = [];
        outDpNames.forEach((item) => {
          // 获取该加工商的模具信息

          let mouldBomsInfo = outMouldBoms.filter((item1) => {
            return (item1.ProductionDpName = item);
          });

          let outRubbers = [];
          let outDetailModels = [];

          let mouldBomsInfoIds = mouldBomsInfo.map((item1) => item1.MouldBomNo);
          console.log("打印==mouldBomsInfoIds========", mouldBomsInfoIds);
          // 根据模具信息获取对应的胶件，材料信息
          rubbers.forEach((v) => {
            if (mouldBomsInfoIds.indexOf(v.MouldBomNo) !== -1) {
              outRubbers.push(v);
            }
          });

          DetailModels.forEach((v) => {
            if (mouldBomsInfoIds.indexOf(v.MouldBomNo) !== -1) {
              outDetailModels.push(...v.DetailModels);
            }
          });

          console.log("打印==outDetailModels========", outDetailModels);

          // 给胶件赋值上对应的工单号
          outRubbers.forEach((item) => {
            for (let i = 0; i < mouldBomsInfo.length; ++i) {
              if (item.MouldBomNo === mouldBomsInfo[i].MouldBomNo) {
                item.WorkDocNo = mouldBomsInfo[i].WorkDocNo;
                break;
              }
            }
          });

          //  合并材料
          let sumMaterialModels = [];

          let copyMaterialModels = JSON.parse(JSON.stringify(outDetailModels));

          copyMaterialModels.forEach((item1) => {
            let pds = sumMaterialModels.map((item1) => item1.ProductId);
            if (pds.indexOf(item1.ProductId) === -1) {
              sumMaterialModels.push(item1);
            } else {
              let length = sumMaterialModels.length;
              for (let i = 0; i < length; ++i) {
                if (item1.ProductId === sumMaterialModels[i].ProductId) {
                  sumMaterialModels[i].Quantity =
                    sumMaterialModels[i].Quantity + item1.Quantity;
                  break;
                }
              }
            }
          });

          let printData = {
            ClothRemark,
            OrderDate,
            OrderProductNo,
            DpName: item,
            FinishDate,
            ProductName,
            ProductModels: outMouldBoms,
            RubberModels: outRubbers,
            MaterialModels: outDetailModels,
            sumMaterialModels: sumMaterialModels,
          };

          printList.push(printData);
        });

        // 缓存
        localStorage.setItem("printList", JSON.stringify(printList));

        this.$emit("printed");
        this.close();

        // 自产委外都打印
      } else if (this.isSelfProduced && this.isOutsourcing) {
        // 先搞出自产的
        let printList = [];

        {
          // 获取自产的模具信息
          let selfMouldBoms = mouldBoms.filter((item) => {
            return item.ProductionType === 0;
          });

          // 获取对应模具的胶件和材料
          let selfMouldBomsIds = selfMouldBoms.map((item) => item.MouldBomNo);

          let selfRubbers = [];
          let selfDetailModels = [];

          rubbers.forEach((item) => {
            if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
              selfRubbers.push(item);
            }
          });

          DetailModels.forEach((item) => {
            if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
              selfDetailModels.push(...item.DetailModels);
            }
          });

          // 给胶件赋值上对应的工单号
          selfRubbers.forEach((item) => {
            for (let i = 0; i < selfMouldBoms.length; ++i) {
              if (item.MouldBomNo === selfMouldBoms[i].MouldBomNo) {
                item.WorkDocNo = selfMouldBoms[i].WorkDocNo;
                break;
              }
            }
          });

          //  合并材料
          let sumMaterialModels = [];

          let copyMaterialModels = JSON.parse(JSON.stringify(selfDetailModels));

          copyMaterialModels.forEach((item) => {
            let pds = sumMaterialModels.map((item) => item.ProductId);
            if (pds.indexOf(item.ProductId) === -1) {
              sumMaterialModels.push(item);
            } else {
              let length = sumMaterialModels.length;
              for (let i = 0; i < length; ++i) {
                if (item.ProductId === sumMaterialModels[i].ProductId) {
                  sumMaterialModels[i].Quantity =
                    sumMaterialModels[i].Quantity + item.Quantity;
                  break;
                }
              }
            }
          });

          let printData = {
            ClothRemark,
            OrderDate,
            OrderProductNo,
            DpName,
            FinishDate,
            ProductName,
            ProductModels: selfMouldBoms,
            RubberModels: selfRubbers,
            MaterialModels: selfDetailModels,
            sumMaterialModels: sumMaterialModels,
          };

          printList.push(printData);
        }

        {
          // 获取委外的模具信息
          let outMouldBoms = mouldBoms.filter((item) => {
            return item.ProductionType === 1;
          });

          // 没有勾选，默认全部加工商都要
          let outDpNames = [];
          if (this.checkList.length === 0) {
            outDpNames = outMouldBoms.map((item) => {
              return item.ProductionDpName;
            });
            outDpNames = Array.from(new Set(outDpNames));
          } else {
            outDpNames = this.checkList;
          }

          outDpNames.forEach((item) => {
            // 获取该加工商的模具信息

            let mouldBomsInfo = outMouldBoms.filter((item1) => {
              return (item1.ProductionDpName = item);
            });

            let outRubbers = [];
            let outDetailModels = [];

            let mouldBomsInfoIds = mouldBomsInfo.map((item1) => item1.MouldBomNo);
            console.log("打印==mouldBomsInfoIds========", mouldBomsInfoIds);
            // 根据模具信息获取对应的胶件，材料信息
            rubbers.forEach((v) => {
              if (mouldBomsInfoIds.indexOf(v.MouldBomNo) !== -1) {
                outRubbers.push(v);
              }
            });

            DetailModels.forEach((v) => {
              if (mouldBomsInfoIds.indexOf(v.MouldBomNo) !== -1) {
                outDetailModels.push(...v.DetailModels);
              }
            });

            console.log("打印==outDetailModels========", outDetailModels);

            // 给胶件赋值上对应的工单号
            outRubbers.forEach((item) => {
              for (let i = 0; i < mouldBomsInfo.length; ++i) {
                if (item.MouldBomNo === mouldBomsInfo[i].MouldBomNo) {
                  item.WorkDocNo = mouldBomsInfo[i].WorkDocNo;
                  break;
                }
              }
            });

            //  合并材料
            let sumMaterialModels = [];

            let copyMaterialModels = JSON.parse(
              JSON.stringify(outDetailModels)
            );

            copyMaterialModels.forEach((item1) => {
              let pds = sumMaterialModels.map((item1) => item1.ProductId);
              if (pds.indexOf(item1.ProductId) === -1) {
                sumMaterialModels.push(item1);
              } else {
                let length = sumMaterialModels.length;
                for (let i = 0; i < length; ++i) {
                  if (item1.ProductId === sumMaterialModels[i].ProductId) {
                    sumMaterialModels[i].Quantity =
                      sumMaterialModels[i].Quantity + item1.Quantity;
                    break;
                  }
                }
              }
            });

            let printData = {
              ClothRemark,
              OrderDate,
              OrderProductNo,
              DpName: item,
              FinishDate,
              ProductName,
              ProductModels: outMouldBoms,
              RubberModels: outRubbers,
              MaterialModels: outDetailModels,
              sumMaterialModels: sumMaterialModels,
            };

            printList.push(printData);
          });
        }

        // 缓存
        localStorage.setItem("printList", JSON.stringify(printList));

        this.$emit("printed");
        this.close();

        // 全部打印
      } else if (!this.isSelfProduced && !this.isOutsourcing) {
        // 先搞出自产的
        let printList = [];

        {
          // 获取自产的模具信息
          let selfMouldBoms = mouldBoms.filter((item) => {
            return item.ProductionType === 0;
          });

          // 获取对应模具的胶件和材料
          let selfMouldBomsIds = selfMouldBoms.map((item) => item.MouldBomNo);

          let selfRubbers = [];
          let selfDetailModels = [];

          rubbers.forEach((item) => {
            if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
              selfRubbers.push(item);
            }
          });

          DetailModels.forEach((item) => {
            if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
              selfDetailModels.push(...item.DetailModels);
            }
          });

          // 给胶件赋值上对应的工单号
          selfRubbers.forEach((item) => {
            for (let i = 0; i < selfMouldBoms.length; ++i) {
              if (item.MouldBomNo === selfMouldBoms[i].MouldBomNo) {
                item.WorkDocNo = selfMouldBoms[i].WorkDocNo;
                break;
              }
            }
          });

          //  合并材料
          let sumMaterialModels = [];

          let copyMaterialModels = JSON.parse(JSON.stringify(selfDetailModels));

          copyMaterialModels.forEach((item) => {
            let pds = sumMaterialModels.map((item) => item.ProductId);
            if (pds.indexOf(item.ProductId) === -1) {
              sumMaterialModels.push(item);
            } else {
              let length = sumMaterialModels.length;
              for (let i = 0; i < length; ++i) {
                if (item.ProductId === sumMaterialModels[i].ProductId) {
                  sumMaterialModels[i].Quantity =
                    sumMaterialModels[i].Quantity + item.Quantity;
                  break;
                }
              }
            }
          });

          let printData = {
            ClothRemark,
            OrderDate,
            OrderProductNo,
            DpName,
            FinishDate,
            ProductName,
            ProductModels: selfMouldBoms,
            RubberModels: selfRubbers,
            MaterialModels: selfDetailModels,
            sumMaterialModels: sumMaterialModels,
          };

          printList.push(printData);
        }

        {
          // 获取委外的模具信息
          let outMouldBoms = mouldBoms.filter((item) => {
            return item.ProductionType === 1;
          });

          // 没有勾选，默认全部加工商都要
          let outDpNames = [];
          if (this.checkList.length === 0) {
            outDpNames = outMouldBoms.map((item) => {
              return item.ProductionDpName;
            });
            outDpNames = Array.from(new Set(outDpNames));
          } else {
            outDpNames = this.checkList;
          }

          outDpNames.forEach((item) => {
            // 获取该加工商的模具信息

            let mouldBomsInfo = outMouldBoms.filter((item1) => {
              return (item1.ProductionDpName = item);
            });

            let outRubbers = [];
            let outDetailModels = [];

            let mouldBomsInfoIds = mouldBomsInfo.map((item1) => item1.MouldBomNo);
            console.log("打印==mouldBomsInfoIds========", mouldBomsInfoIds);
            // 根据模具信息获取对应的胶件，材料信息
            rubbers.forEach((v) => {
              if (mouldBomsInfoIds.indexOf(v.MouldBomNo) !== -1) {
                outRubbers.push(v);
              }
            });

            DetailModels.forEach((v) => {
              if (mouldBomsInfoIds.indexOf(v.MouldBomNo) !== -1) {
                outDetailModels.push(...v.DetailModels);
              }
            });

            console.log("打印==outDetailModels========", outDetailModels);

            // 给胶件赋值上对应的工单号
            outRubbers.forEach((item) => {
              for (let i = 0; i < mouldBomsInfo.length; ++i) {
                if (item.MouldBomNo === mouldBomsInfo[i].MouldBomNo) {
                  item.WorkDocNo = mouldBomsInfo[i].WorkDocNo;
                  break;
                }
              }
            });

            //  合并材料
            let sumMaterialModels = [];

            let copyMaterialModels = JSON.parse(
              JSON.stringify(outDetailModels)
            );

            copyMaterialModels.forEach((item1) => {
              let pds = sumMaterialModels.map((item1) => item1.ProductId);
              if (pds.indexOf(item1.ProductId) === -1) {
                sumMaterialModels.push(item1);
              } else {
                let length = sumMaterialModels.length;
                for (let i = 0; i < length; ++i) {
                  if (item1.ProductId === sumMaterialModels[i].ProductId) {
                    sumMaterialModels[i].Quantity =
                      sumMaterialModels[i].Quantity + item1.Quantity;
                    break;
                  }
                }
              }
            });

            let printData = {
              ClothRemark,
              OrderDate,
              OrderProductNo,
              DpName: item,
              FinishDate,
              ProductName,
              ProductModels: outMouldBoms,
              RubberModels: outRubbers,
              MaterialModels: outDetailModels,
              sumMaterialModels: sumMaterialModels,
            };

            printList.push(printData);
          });
        }

        // 缓存
        localStorage.setItem("printList", JSON.stringify(printList));

        this.$emit("printed");
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
